import {getCookie} from "../utils";

// 根据cookie来判断是否登录
function checkLogin () {
    const q = getCookie('_q') || '';
    const t = getCookie('_t') || '';
    if (q !== '' && t !== '' && (q.startsWith('U') || q.startsWith('"U'))) {
        return true;
    }
    return false;
}

export {
    checkLogin
}
